module.exports = __webpack_public_path__ + "static/media/iphone.ba7def66.png";